import {FormControlLabel, FormControlLabelProps, styled} from '@mui/material';
import {Tooltip} from '../../../tooltip/tooltip';

export const StyledRadioLabel = styled((props: FormControlLabelProps) => (
  <FormControlLabel {...props} />
))(({theme, checked}) => ({
  '.MuiFormControlLabel-label': {
    color: checked ? 'var(--dcm-blue-base)' : 'var(--dcm-gray)',
  },
}));

export function RadioLabel(props: FormControlLabelProps) {
  return <StyledRadioLabel {...props} />;
}

interface RadioTooltipProps extends FormControlLabelProps {
  disabledTooltip?: string;
}

RadioLabel.Tooltip = ({disabledTooltip, className, ...rest}: RadioTooltipProps) => {
  if (rest.disabled)
    return (
      <Tooltip notAllowedCursor title={disabledTooltip} className={className}>
        <RadioLabel {...rest} />
      </Tooltip>
    );

  return <RadioLabel className={className} {...rest} />;
};
